import Filter from './Filter';
import fetchProducts from '@/core/product/searchProductByVehicle'
import { Card, Result, Row, Spin, Col, Tabs, Collapse, Button, List, Tooltip, Checkbox, Divider, Form, Input, Tag, message, Select, Pagination, Progress } from 'antd'
// İkonlar import edildi
import { SearchOutlined, UpOutlined } from '@ant-design/icons'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import VehicleInfo from '@/components/assistant/Vehicle/VehicleInfo'
import LittleMenu from '@/components/assistant/Vehicle/VehicleLittleMenu';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

import useProductApplicationReducer from './useApplicationReducer';

import Product from '@/components/products/Product';

import fetchPriceAndRoute from '@/core/price/fetchPriceAndRoute';
import fetchPriceAndRoutev2 from '@/core/price/fetchPriceAndRoutev2';

// import useUpdatePartsArea from './useUpdatePartsArea';
import { getSortKey } from '@/core/avability/avability';
import { useSelector } from 'react-redux';
import getCatalogName from '@/helpers/getCatalogName';


function markStarProducts(catalogData, mostSelling) {
  try {
    const productGroupMap = new Map();

    catalogData.forEach((product, index) => {
      const groupId = product.CatalogProductGroupId;
      if (!productGroupMap.has(groupId)) {
        productGroupMap.set(groupId, []);
      }
      productGroupMap.get(groupId).push(index);
    });

    const rowIdToSellingQuantity = new Map();

    (mostSelling || []).forEach(item => {
      rowIdToSellingQuantity.set(item.row_id, item.selling_quantity);
    });

    productGroupMap.forEach(groupIndexes => {
      let highestSellingProductIndex = null;
      let maxSellingQuantity = 0;

      groupIndexes.forEach(index => {
        const product = catalogData[index];
        const rowIds = product.avability?.data?.map(data => data.rowId) || [];

        const productMaxSelling = rowIds.reduce((max, rowId) => {
          return Math.max(max, rowIdToSellingQuantity.get(rowId) || 0);
        }, 0);

        if (productMaxSelling > maxSellingQuantity) {
          maxSellingQuantity = productMaxSelling;
          highestSellingProductIndex = index;
        }
      });

      if (highestSellingProductIndex !== null) {
        catalogData[highestSellingProductIndex].isStar = 1;
      }
    });

    catalogData.forEach(product => {
      if (product.isStar !== 1) {
        product.isStar = 0;
      }
    });

    return catalogData;
  } catch (error) {
    console.error(error);
    return catalogData;
  }
}

const VehiclePartsArea = ({ catalogBrandId, searchArea, series, plate, menu, productGroupId, productReference, onClickMenu, render, oem, searchDescription }) => {
  const appReducer = useProductApplicationReducer()
  const { t } = useTranslation();
  const [keyProductsRender, setKeyProductsRender] = useState(0)
  
  // 1. Buton görünürlüğü için state
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const refSearch = useRef()
  const paginationRef = useRef();
  
  // En tepeye referans
  const mainContentRef = useRef(null);

  const account = useSelector(e => e.session)
  const language = useSelector(e => e.settings.Language)

  // 2. Scroll dinleyicisi
  useEffect(() => {
    const handleScroll = () => {
      // 400px aşağı inilirse butonu göster
      // if (window.scrollY > 200) {
      //   setShowScrollBtn(true);
      // } else {
      //   setShowScrollBtn(false);
      // }
      setShowScrollBtn(true)
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 3. Yukarı çıkma fonksiyonu
  const handleScrollToTop = () => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const onSetDescriptionHandler = () => {
    if (!(refSearch.current.value.length >= 3 || refSearch.current.value == ''))
      return message.info("Description minimum 3 character.")
    appReducer.dispatch({ type: 'setDescription', payload: refSearch.current.value })
  }

  useEffect(() => {
    appReducer.dispatch({ type: 'setProducts', payload: [] })
    appReducer.dispatch({ type: 'setLoadingProducts', payload: true })
    fetchProducts({
      series: series,
      productGroupId: productGroupId,
      menuCode: menu,
      productReference: productReference,
      oem: oem,
      searchDescription: searchDescription,
      catalogBrandId
    }).then((result) => {
      let priceListData = []

      appReducer.dispatch({ type: 'setOriginalProducts', payload: result.products })

      let overrideResult = [...result.filters];

      const inbouwplaatsIndex = overrideResult.findIndex(f => f.Name === "Inbouwplaats" || f.Name === "Einbauposition" || f.Name === "Positions" || f.Name === "Montageposition" || f.Name === "Montageort" || f.Name === "Côté d'assemblage" || f.Name === "Montageorte");
     
      if (inbouwplaatsIndex !== -1 && inbouwplaatsIndex !== 1) {
        const [inbouwplaatsItem] = overrideResult.splice(inbouwplaatsIndex, 1);
        overrideResult.splice(1, 0, inbouwplaatsItem);
      }

      appReducer.dispatch({ type: 'setFiltersData', payload: overrideResult })
      appReducer.dispatch({ type: 'setFilterTree', payload: result.filterTree })

      for (let i = 0; i < result.products.length; i++) {
        priceListData.push({ key: result.products[i]._id, rows: result.products[i].RowIds })
        result.products[i].loadingAvability = true;
      }
      appReducer.dispatch({ type: 'setProducts', payload: result.products })
      
      fetchPriceAndRoutev2(JSON.stringify(priceListData)).then((e) => {
        let i = 0;
        for (const item of result.products) {
          let findIndex = e.data.findIndex(x => x.key == item._id)
          let find = e.data[findIndex]
          if (findIndex != -1) {
            result.products[i].sortKey = find?.index
            result.products[i].avability = {
              data: find.data,
              fastestRowId: find.fastestRowId,
            }
            result.products[i].loadingAvability = false
          } else {
            result.products[i].sortKey = Infinity
            result.products[i].avability = null;
            result.products[i].loadingAvability = false
          }
          i++;
        }
        result.products = markStarProducts(result.products, e.mostSelling);

        result.products = result.products.sort((a, b) => {
          if (a.sortKey === b.sortKey) {
            return b.isStar - a.isStar;
          }
          return a.sortKey - b.sortKey;
        });

        let includeOEM = appReducer.state.includedOEMProducts;
        if (!includeOEM) {
          result.products = result.products.filter(c => c?.BrandName != 'OEM');
        }

        appReducer.dispatch({ type: 'setProducts', payload: result.products })
        appReducer.dispatch({ type: 'setDeliveries', payload: e.deliveries })

      }).catch(f => {
      }).finally(() => {
        setKeyProductsRender(keyProductsRender + 1)
      })

    }).catch(e => {
      appReducer.dispatch({ type: 'setError', payload: true })
    }).finally(e => {
      appReducer.dispatch({ type: 'setLoadingProducts', payload: false })
    })
  }, [series, plate, menu, productGroupId, oem, searchDescription, account?.relationId, language, appReducer.state.includedOEMProducts])

  const catalogName = useMemo(() => getCatalogName(), [])

  return (
    <div ref={mainContentRef}>
      {series || plate ? <VehicleInfo Plate={plate} Series={series} /> : null}
      {catalogName != 'TECDOC' && (series || plate || menu) ? <LittleMenu onClick={onClickMenu} menuCode={menu} /> : null}
      <div className='mt-[10px]'>
        {appReducer.state.loadingProducts ? <Card className="searching-card mt-[10px]">
          <Result
            icon={
              <div>
                <img src="https://material.parts-soft.net/webshop-media/searching.gif" />
              </div>
            }
            title={t('we-are-looking-for-your-product-please-wait')}
          />
        </Card> :
          <div style={{ position: 'relative' }}>
            <Row gutter={12}>
              <Col lg={6} sm={{ span: 24, justify: 'end', }} xs={{ span: 24, justify: 'end' }} >
                <div className='mb-[10px]'>
                  {searchArea}
                </div>
                <Filter reducer={appReducer} />
              </Col>
              <Col key={keyProductsRender} lg={18} sm={{
                span: 24,
                justify: 'end',
              }} xs={{
                span: 24,
                justify: 'end'
              }}>
                {appReducer.state.products.length == 0 ? <Card className="searching-card mt-[10px]">
                  <Result
                    icon={
                      <>
                        <img src="https://material.parts-soft.net/webshop-media/product-not-found.png" />
                      </>
                    }
                    title={t('not-found-product-text')}
                    subTitle={productReference?.toUpperCase()}
                  />
                </Card> : <div key={keyProductsRender}>{appReducer.state.products.slice((appReducer.state.currentPage - 1) * appReducer.state.perPage, appReducer.state.currentPage * appReducer.state.perPage).map((item, key) =>
                  <Product Series={series} deliveries={appReducer.state.deliveries} plate={plate} ProductReference={item.ProductReference} onlyAvability={false} product={item} key={key} />
                )}
                  <div ref={paginationRef} ></div>
                  <Pagination style={{ marginTop: '20px' }} showSizeChanger={false} onChange={(e) => {
                    appReducer.dispatch({ type: 'setCurrentPage', payload: e })
                    if (mainContentRef.current) {
                      mainContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }} current={appReducer.state.currentPage} total={appReducer.state.totalCount} pageSize={appReducer.state.perPage} />
                </div>}
              </Col>
            </Row>
          </div>
        }
      </div>
      {/* 4. Scroll To Top Butonu */}
      {showScrollBtn && (
        <Tooltip title={t('scroll-to-top')}>
          <Button
            type="primary"
            shape="circle"
            icon={<UpOutlined />}
            size="large"
            onClick={handleScrollToTop}
            style={{
              position: 'fixed', // Ekrana sabitlenmesi için fixed kullanıldı
              bottom: '40px',
              right: '40px',
              zIndex: 1000,
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50px',
              width: '50px',
            }}
          />
        </Tooltip>
      )}
    </div>
  )
}

export default VehiclePartsArea